import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";
import OraTimeButton from "../components/voice/OraTimeButton";
import OrientationControlButton from "../components/OrientationControlButton";

/**
 * TIME Watch Hub
 * Nuova schermata iniziale del TIME Watch che presenta le tre modalità:
 *  ① TIME Watch (PMV esistente)
 *  ② Utility
 *  ③ Orologio
 *
 * IMPORTANTE: non contiene logica funzionale, è solo un contenitore di
 * navigazione. Il PMV originale non è stato modificato.
 */
const MODES = [
  {
    slug: "pmv",
    icon: "/icons/timewatch/time-watch.png",
    title: "TIME Watch",
    subtitle: "Il tuo tempo, letto come denaro",
    to: "/innovazione/time-watch/pmv",
  },
  {
    slug: "utility",
    icon: "/icons/timewatch/utility.png",
    title: "Utility",
    subtitle: "Strumenti di supporto",
    to: "/innovazione/time-watch/utility",
  },
  {
    slug: "orologio",
    icon: "/icons/timewatch/orologio.png",
    title: "Orologio",
    subtitle: "Modalità orologio",
    to: "/innovazione/time-watch/orologio",
  },
];

export default function TimeWatchHubPage() {
  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to="/innovazione"
        data-testid="time-watch-hub-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        Innovazione
      </Link>

      <PageHeader
        eyebrow="Innovazione"
        title="TIME Watch"
        description="Scegli una modalità."
        testId="time-watch-hub-header"
      />

      <div
        data-testid="time-watch-hub-grid"
        className="grid grid-cols-3 gap-3 sm:gap-6"
      >
        {MODES.map((m) => (
          <Link
            key={m.slug}
            to={m.to}
            data-testid={`time-watch-mode-${m.slug}`}
            className="group block"
          >
            <div className="relative aspect-square rounded-xl overflow-hidden bg-black border border-white/5 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.6)] transition-all duration-500 group-hover:-translate-y-1 sm:group-hover:-translate-y-2 group-hover:shadow-[0_25px_60px_-15px_rgba(16,185,129,0.35)] group-hover:border-emerald-400/25 flex items-center justify-center p-2 sm:p-3">
              <img
                src={m.icon}
                alt=""
                aria-hidden="true"
                loading="lazy"
                draggable={false}
                className="max-w-full max-h-full w-auto h-auto object-contain select-none scale-[1.10] transform-gpu"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
            </div>
            <div className="mt-2 sm:mt-3 px-0.5 sm:px-1 text-center sm:text-left">
              <div className="text-[12px] sm:text-sm md:text-base font-light text-white leading-snug tracking-tight group-hover:text-emerald-200 transition-colors">
                {m.title}
              </div>
              <div className="hidden sm:block mt-1 text-[11px] font-light text-white/40 leading-relaxed line-clamp-2">
                {m.subtitle}
              </div>
            </div>
          </Link>
        ))}
      </div>
      <OraTimeButton />
      <OrientationControlButton />
    </div>
  );
}
